import React from "react";
import "../../App.css";
import CompilerError from "../CompilerError";
import Problem from "../Problem";
import Suggestion from "../Suggestion";
import BadExample from "../BadExample";
import GoodExample from "../GoodExample";
import { makeClassStubIfUnknown, makeDemoValue } from "../../demoValues";

class ReturnMissing extends React.Component {

  render() {
    const demoValue = makeDemoValue(this.props.typeName);
    const extraDemoValue = makeDemoValue(this.props.typeName);
    const classPlaceholder = <div className="Indent-0">{makeClassStubIfUnknown(this.props.typeName)}</div>;

    const demoConditional = "/* a condition */";

    const requiredTypes = this.props.requiredTypes.split(",");
    const numParams = requiredTypes.length;
    let separatedDeclarationArgs = [];
    if (requiredTypes[0].length > 0) {
      separatedDeclarationArgs = [...Array(numParams).keys()].map((index) => `${requiredTypes[index]} param${index + 1}`);
    }
    const declarationArgs = separatedDeclarationArgs.join(", ");

    const LEFT_CURLY = "{";
    const RIGHT_CURLY = "}";

    // eslint-disable-next-line
    const abbreviatedComment = "/* your code */";

    return <CompilerError
      title={<>This method must return a result of type{" "}
        <div className="InputValue">{this.props.typeName}</div></>}
      translation={<>You did not return a value of type{" "}
        <div className="InputValue">{this.props.typeName}</div> like the definition of method{" "}
        <div className="InputValue">{this.props.methodName}()</div>.</>}
      embed={this.props.embed} 
      fontSize={this.props.fontSize}
    >
      <Problem
        title={<>You may have forgotten the return statement for the method{" "}
          <p className="InputValue">{this.props.methodName}()</p>.</>}
      >
        <Suggestion title={<>Add a return statement of type{" "}
          <p className="InputValue">{this.props.typeName}</p> at the end of the method{" "}
          <p className="InputValue">{this.props.methodName}()</p>.</>}>
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName} {this.props.methodName}({declarationArgs}) {LEFT_CURLY}</div>
            <div className="Indent-1"> {abbreviatedComment}</div>
            <div className="Indent-0"> {RIGHT_CURLY}</div>
          </BadExample>
          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName} {this.props.methodName}({declarationArgs}) {LEFT_CURLY}</div>
            <div className="Indent-1"> {abbreviatedComment}</div>
            <div className="Indent-1"> return {demoValue};</div>
            <div className="Indent-0"> {RIGHT_CURLY}</div>
          </GoodExample>
        </Suggestion>
      </Problem>
      <Problem
        title={<>You may have missed the return statement in some branches
          of the method{" "}
          <p className="InputValue">{this.props.methodName}()</p>.</>}
      >
        <Suggestion title={<>Make sure all branches of conditionals in method{" "}
          <p className="InputValue">{this.props.methodName}()</p>{" "} return value of type{" "}
          <p className="InputValue">{this.props.typeName}</p>.</>}>
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName} {this.props.methodName}({declarationArgs}) {LEFT_CURLY}</div>
            <div className="Indent-1"> if ({demoConditional}) return {extraDemoValue};</div>
            <div className="Indent-0"> {RIGHT_CURLY}</div>
          </BadExample>
          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName} {this.props.methodName}({declarationArgs}) {LEFT_CURLY}</div>
            <div className="Indent-1"> if ({demoConditional}) return {extraDemoValue};</div>
            <div className="Indent-1"> return {demoValue};</div>
            <div className="Indent-0"> {RIGHT_CURLY}</div>
          </GoodExample>
          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName} {this.props.methodName}({declarationArgs}) {LEFT_CURLY}</div>
            <div className="Indent-1"> if ({demoConditional}) {LEFT_CURLY}</div>
            <div className="Indent-2"> return {extraDemoValue};</div>
            <div className="Indent-1"> {RIGHT_CURLY} else {LEFT_CURLY}</div>
            <div className="Indent-2"> return {demoValue};</div>
            <div className="Indent-1"> {RIGHT_CURLY}</div>
            <div className="Indent-0"> {RIGHT_CURLY}</div>
          </GoodExample>
        </Suggestion>
      </Problem>
    </CompilerError>;
  }
}

export default ReturnMissing;